import EntryPoint from "Engine/EntryPoint";

export default new class NearWinCalculator {
    constructor() {
        this._calculateReels = [0, 1, 2, 3, 4];
        this._nearReels = [];
        this._searchSymbol = 1;

        EntryPoint.NearWinCalculator = this;
    }

    calculate() {
        this._nearReels = [];
        let found = [];
        this._calculateReels.forEach((index) => {
            EntryPoint.GameModel.reels[index].forEach((symbol) => {
                if (symbol === this._searchSymbol) {
                    found.push(index);
                }
            })
        });
        /*switch (found.length) {
            default:
        }*/
        if(found.length >= 2) {
            let value = found[1];
            if(value <= 3) {
                for(let i = value + 1; i < 5; i++) {
                    this._nearReels.push(i);
                }
            }
        }
    }

    reset() {
        this._nearReels = [];
    }

    checkForReel(index) {
        return this.nearReels.indexOf(index) !== -1;
    }

    get nearReels() {
        return this._nearReels;
    }
}